import React, { useEffect } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { View } from 'react-native';
import { styled } from 'dripsy';
import { PaymentElement } from '@stripe/react-stripe-js';
import { reaction } from 'mobx';

import { IPaymentFormProps } from './PaymentForm';

const Container = styled(View)({});

export const PaymentForm = observer(
  ({ onChangeStatus }: IPaymentFormProps) => {
    const store = useLocalObservable(() => ({
      complete: false,

      setComplete(value: boolean) {
        this.complete = value;
      },
    }));

    useEffect(() => {
      reaction(
        () => store.complete,
        (value) => {
          onChangeStatus?.(value);
        },
      );
    }, []);

    return (
      <Container>
        <PaymentElement
          onChange={(e) => store.setComplete(e.complete)}
        />
      </Container>
    );
  },
);
